import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/builds/1tool/inspect/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/1tool/inspect/layouts/default.vue").then(m => m.default || m))
}